var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.36287V7.6272H9.94572C10.848 7.6272 11.6375 7.6272 12.8577 7.54775C11.8836 8.31245 11.0326 9.11688 10.1508 9.95111L8.64355 11.4011L10.2943 13L17 6.49503L10.2943 0L8.64355 1.59893L10.1508 3.03896C11.0326 3.88312 11.8836 4.67762 12.8577 5.45225C11.6375 5.36287 10.848 5.36287 9.94572 5.36287H0Z",
    fill: "#fffbf4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWhite);
export default __webpack_public_path__ + "static/media/arrow-white.467edf292591ab5c033eb1bbf1a9f035.svg";
export { ForwardRef as ReactComponent };